import { Building2 } from "lucide-react"
import AmenityIcon from "./ameniy-icon"
import { Amenity } from "@/app/types"

const NotFound = () => {
  return (
    <div className="border-border/40 rounded-xl border bg-white px-4 py-12 text-center shadow-sm">
      <div className="bg-secondary/50 mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full">
        <Building2 className="text-muted-foreground" size={28} strokeWidth={1.5} />
      </div>
      <h3 className="mb-2 text-xl font-medium">No Amenities Available</h3>
      <p className="text-muted-foreground mx-auto max-w-md">
        This property doesn't have any registered amenities at the moment. Please check back later or contact the
        property manager for more information.
      </p>
    </div>
  )
}


export const RenderAmenities = ({ amenities }: { amenities: Amenity[] }) => {
  if (amenities.length === 0) {
    return null
  }

  return (
    <div className="mt-2 grid grid-cols-1 gap-4 sm:grid-cols-2">
      {amenities.map((amenity) => (
        <div
          key={amenity._id}
          className="hover:bg-secondary/30 flex items-start gap-3 rounded-lg p-3 transition-colors"
        >
          <div className="flex-shrink-0 rounded-full bg-black p-2 text-white">
            <AmenityIcon name={amenity.icon as any} size={18} />
          </div>
          <div>
            <h4 className="text-sm font-medium">{amenity.name}</h4>
            <p className="text-muted-foreground text-xs">{amenity.description}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
